jQuery(document).ready(function ($) {
    $('.frequently-asked-questions__question').on('click', function () {
        const $item = $(this).closest('.frequently-asked-questions__item');
        const $answer = $item.find('.frequently-asked-questions__answer').first();

        if ($item.hasClass('is-open')) {
            $answer.slideUp(300, function () {
                $item.removeClass('is-open');
            });
        } else {
            $item.addClass('is-open');
            $answer.slideDown(300);
        }
    });
});
